import PublicProfile from '@/core/pages/profile/PublicProfile/PublicProfile';

export default PublicProfile;
